<template>
  <div class="module">
    <div class="module-header flex items-center justify-between">
      <div class="module-header-title bold flex items-center">
        {{title}}
        <slot name="title-right-tag" />
      </div>
      <slot name="header-right" />
    </div>
    <div class="module-content white-bg">
      <slot default/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  }
}
</script>

<style lang="less" scoped>
.module{
  border-radius: .16rem;
  overflow: hidden;

  &-header{
    color: #fff;
    padding: 0 .34rem;
    height: .84rem;
    background: #D8271C;
    font-size: .24rem;
  }
}
</style>